module.exports = __webpack_public_path__ + "img/decimal_from.243197de.png";